import { c as _c } from "react/compiler-runtime";
import React from "react";
import { MinimalWave } from "@/contexts/wave/hooks/useEnhancedWavesList";
interface UnifiedWavesListEmptyProps {
  readonly sortedWaves: MinimalWave[];
  readonly isFetching: boolean;
  readonly isFetchingNextPage: boolean;
  readonly emptyMessage?: string | undefined;
}
const UnifiedWavesListEmpty: React.FC<UnifiedWavesListEmptyProps> = t0 => {
  const $ = _c(2);
  const {
    sortedWaves,
    isFetching,
    isFetchingNextPage,
    emptyMessage
  } = t0;
  if (sortedWaves.length > 0 || isFetching || isFetchingNextPage) {
    return null;
  }
  const t1 = emptyMessage ?? "No waves to display";
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="tw-px-5 tw-py-4 tw-text-center tw-text-iron-500"><p className="tw-text-sm">{t1}</p></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default UnifiedWavesListEmpty;